import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { usePreferences } from '../data/userProfile.ts'
import { getConversionFunction } from './measurements/convertMeasurements.tsx'

export const useDistanceRangeHelpers = (min: number = 0, max: number = 100) => {
	const { data: preferences } = usePreferences()
	const { t } = useTranslation()
	const distanceUnit = preferences.unitsDistance ?? 'KILOMETRES'

	return useMemo(() => {
		const convertDistanceToUserPreference = getConversionFunction('DISTANCE', distanceUnit, 'KILOMETRES') ?? ((value: number) => value)
		const convertDistanceToKm = getConversionFunction('DISTANCE', 'KILOMETRES', distanceUnit) ?? ((value: number) => value)
		return {
			fromKmToUserPreference: (km: number, decimals = 2) => Number(convertDistanceToUserPreference(km).toFixed(decimals)),
			fromUserPreferenceToKm: (value: number, decimals = 2) => Number(convertDistanceToKm(value).toFixed(decimals)),
			fromKm2ToUserPreference: (km2: number) => km2 * convertDistanceToUserPreference(1) ** 2,
			formattedUnit: t(($) => $.preferences.unitLabels[distanceUnit]),
			formatKmInUserPreferenceUnit: (km: number, delimiter = ' ', decimals = 2) =>
				`${Number(convertDistanceToUserPreference(km).toFixed(decimals))}${delimiter}${t(($) => $.preferences.unitLabels[distanceUnit])}`,
			minDistanceInUserPreferenceUnit: Math.ceil(convertDistanceToUserPreference(min)),
			maxDistanceInUserPreferenceUnit: Math.floor(convertDistanceToUserPreference(max)),
		}
	}, [distanceUnit, t, min, max])
}
